import qs from "qs";

// Action Types
export const LIST = "bontempo/genres/LIST";
export const LIST_SUCCESS = "bontempo/genres/LIST_SUCCESS";
export const LIST_FAIL = "bontempo/genres/LIST_FAIL";

export const DETAILS = "bontempo/genres/DETAILS";
export const DETAILS_SUCCESS = "bontempo/genres/DETAILS_SUCCESS";
export const DETAILS_FAIL = "bontempo/genres/DETAILS_FAIL";

export const SAVE = "bontempo/genres/SAVE";
export const SAVE_SUCCESS = "bontempo/genres/SAVE_SUCCESS";
export const SAVE_FAIL = "bontempo/genres/SAVE_FAIL";

export const DELETE = "bontempo/genres/DELETE";
export const DELETE_SUCCESS = "bontempo/genres/DELETE_SUCCESS";
export const DELETE_FAIL = "bontempo/genres/DELETE_FAIL";

// Reducer
const initialState = {
  data: null,
  details: null,
  loading: false,
  module: "filmes/generos",
  total: 0
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LIST:
      return { ...state, loading: true };
    case LIST_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    case LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case DETAILS:
      return { ...state, loading: true };
    case DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.data,
        loading: false
      };
    case DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: "Não foi possível completar a requisição."
      };

    case SAVE:
      return { ...state, loading: true };
    case SAVE_SUCCESS:
    case SAVE_FAIL:
      return { ...state, loading: false };

    case DELETE:
      return { ...state, loading: true };
    case DELETE_SUCCESS:
    case DELETE_FAIL:
      return { ...state, loading: false };

    default:
      return state;
  }
}

// Action Creators
export function get(params) {
  return {
    type: LIST,
    payload: {
      request: {
        url: `/movies/genres?${qs.stringify(params)}`
      }
    }
  };
}

export function getDetails(id) {
  return {
    type: DETAILS,
    payload: {
      request: {
        url: `/movies/genres/${id}`
      }
    }
  };
}

export function add(data) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/movies/genres`,
        method: "post",
        data: data
      }
    }
  };
}

export function edit(data, id) {
  return {
    type: SAVE,
    payload: {
      request: {
        url: `/movies/genres/${id}`,
        method: "put",
        data: data
      }
    }
  };
}

export function remove(id) {
  return {
    type: DELETE,
    payload: {
      request: {
        url: `/movies/genres/${id}`,
        method: "delete"
      }
    }
  };
}
